var _mask, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_6330_19039",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 23.995C0 10.7429 10.7429 0 23.995 0C37.2471 0 47.99 10.7429 47.99 23.995C47.99 37.2471 37.2471 47.99 23.995 47.99C10.7429 47.99 0 37.2471 0 23.995Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 23.995C0 10.7429 10.7429 0 23.995 0C37.2471 0 47.99 10.7429 47.99 23.995C47.99 37.2471 37.2471 47.99 23.995 47.99C10.7429 47.99 0 37.2471 0 23.995Z",
    fill: "#F9FAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 23.995M47.99 23.995M47.99 23.995M0 23.995M23.995 0M47.99 23.995M23.995 47.99M0 23.995M23.995 47.99V46.9417C11.3219 46.9417 1.04825 36.6681 1.04825 23.995H0H-1.04825C-1.04825 37.826 10.164 49.0382 23.995 49.0382V47.99ZM47.99 23.995H46.9417C46.9417 36.6681 36.6681 46.9417 23.995 46.9417V47.99V49.0382C37.826 49.0382 49.0382 37.826 49.0382 23.995H47.99ZM23.995 0V1.04825C36.6681 1.04825 46.9417 11.3219 46.9417 23.995H47.99H49.0382C49.0382 10.164 37.826 -1.04825 23.995 -1.04825V0ZM23.995 0V-1.04825C10.164 -1.04825 -1.04825 10.164 -1.04825 23.995H0H1.04825C1.04825 11.3219 11.3219 1.04825 23.995 1.04825V0Z",
    fill: "#E9E9E9",
    mask: "url(#path-1-inside-1_6330_19039)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9922 13.9971V17.9971",
    stroke: "#1F1F1F",
    strokeWidth: 1.49969,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9922 13.9971V17.9971",
    stroke: "#1F1F1F",
    strokeWidth: 1.49969,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9889 15.9966H16.9918C15.8874 15.9966 14.9922 16.8918 14.9922 17.9962V31.9932C14.9922 33.0976 15.8874 33.9928 16.9918 33.9928H30.9889C32.0932 33.9928 32.9884 33.0976 32.9884 31.9932V17.9962C32.9884 16.8918 32.0932 15.9966 30.9889 15.9966Z",
    stroke: "#1F1F1F",
    strokeWidth: 1.49969,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9922 21.9956H32.9884",
    stroke: "#1F1F1F",
    strokeWidth: 1.49969,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.bc129c07949c05e05d6a7feae5b5f64c.svg";
export { ForwardRef as ReactComponent };